import React from 'react';

const validate = (e, min, type, required) => {
  const { value = '' } = e.target || {};
  let invalid = false;

  if (!value && required) {
    invalid = true;
  } else if (value) {
    if (type === 'email') {
      const pattern = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
      );
      invalid = !pattern.test(value);
    } else {
      invalid = min > 0 && value.length < min;
    }
  }

  e.target.classList.toggle('is-invalid', invalid);
};

const renderFields = (field, options = {}) => {
  const {
    fieldMeta = null,
    onFieldChange = () => {},
    value = null,
    readOnly = false,
  } = options;

  const placeholder = (field && field.placeholder) || '';

  let defaultValue;
  if (value) {
    defaultValue = value;
  } else if (fieldMeta && field.prefill_value) {
    defaultValue = field.prefill_value;
  } else {
    defaultValue = (field && field.defaultValue) || '';
  }

  const min = (field && field.validation && field.validation.min) || 0;
  const max = (field && field.validation && field.validation.max) || 0;
  const type = (field && field.type) || '';
  const isReadOnly = readOnly || !!value || !!field.readonly;
  const isRequired = field?.validation?.isRequired && field?.validation?.isReadOnly;

  const inputBaseProps = {
    className: 'form-control',
    name: field.name,
    [fieldMeta ? 'value' : 'defaultValue']: defaultValue,
    required: isRequired,
    onChange: (e) => onFieldChange(fieldMeta, e.target.value),
  };

  const optionBaseProps = {
    className: 'form-check-input',
    name: field.name,
    disabled: isReadOnly,
    required: isRequired,
    onBlur: (e) => validate(e, 0, '', isRequired),
  };

  switch (field.toolType) {
    case 'SINGLE_FIELD': {
      const inputType = ['Date', 'Email'].includes(type) ? type.toLowerCase() : 'text';
      const inputProps = {
        ...inputBaseProps,
        placeholder,
        minLength: min,
        maxLength: max,
        readOnly: isReadOnly,
        onBlur: (e) => validate(e, min, inputType, isRequired),
      };
      if (type === 'Textarea') {
        return <textarea {...inputProps} />;
      } else {
        inputProps.type = inputType;
        return <input {...inputProps} />;
      }
    }
    case 'SELECT_FIELD':
      return (
        <select
          {...inputBaseProps}
          disabled={isReadOnly}
          onBlur={(e) => validate(e, 0, '', isRequired)}
        >
          <option value=""></option>
          {field.options.map((option) => (
            <option value={option.value} key={option.value}>
              {option.title}
            </option>
          ))}
        </select>
      );
    case 'RADIO_BUTTONS':
      return field.radios.map((option) => (
        <div className="form-check" key={option.value}>
          <input
            {...optionBaseProps}
            type="radio"
            value={option.value}
            defaultChecked={fieldMeta && field.prefill_value && field.prefill_value === option.value}
            onChange={() => onFieldChange(fieldMeta, option.value)}
          />
          <label className="form-check-label">{option.title}</label>
        </div>
      ));
    case 'CHECK_BOXES':
      return field.checkBoxes.map((option) => (
        <div className="form-check" key={option.value}>
          <input
            {...optionBaseProps}
            type="checkbox"
            value={option.value}
            defaultChecked={
              fieldMeta && field.prefill_value
                ? field.prefill_value.split(',').map(v => v.trim()).includes(option.value)
                : false
            }
            onChange={(e) =>
              onFieldChange(
                fieldMeta,
                e.target.checked
                  ? (field.prefill_value ? field.prefill_value + ',' + option.value : option.value)
                  : field.prefill_value.split(',').filter(v => v.trim() !== option.value).join(',')
              )
            }
          />
          <label className="form-check-label">{option.title}</label>
        </div>
      ));
    case 'PARAGRAPH':
      if (fieldMeta) {
        return (
          <textarea
            className="form-control"
            name={field.name}
            defaultValue={field.prefill_value || field.content}
            onChange={(e) => onFieldChange(fieldMeta, e.target.value)}
          />
        );
      }
      return <div>{field.content}</div>;
    default:
      return null;
  }
};

export default renderFields;
